import React, {useEffect, useState} from 'react';
import AddDataModal from "./AddDataModal";
import EditDataModal from "./EditDataModal";
// import Paginator from "../../components/common/Paginator/Paginator";

const ProductTypes = React.memo(({productTypes, ...props}) => {
    let [isEditProductType, setIsEditProductType] =useState(false);
    let [isCreateProductType, setIsCreateProductType] =useState(false)
    let [productTypeId, setProductTypeId]=useState()
    const [show, setShow] = useState(false);

    useEffect((  )=>{
        if(isCreateProductType) setShow(isCreateProductType)
    },[isCreateProductType])

    useEffect((  )=>{
        if(isEditProductType) setShow(isEditProductType)
    },[isEditProductType])

    const EditProductType =(event)=>{
        debugger
        console.log(event.target.id)
        setProductTypeId(event.target.id)
        setIsEditProductType(true)
        // updateGroupTh(building)
    }

    const AddProductType=()=>
    {
        setIsCreateProductType(true);
    }
    // let productType= [
    //     {id:1,name:'Təlim',status:1},
    //     {id:2,name:'Konfrans',status:1},
    //     {id:3,name:'Webinar',status:1},
    //     ]
    let productTypesList = productTypes.map( productType =>
        <tr key={productType.id}>
            <td>{productType.id}</td>
            <td>{productType.name}</td>
            <td>{productType.status ===1 ?
                <span className="badge badge-pill badge-success">Active</span>
                :<span className="badge badge-pill badge-danger">Deactive</span>
            }</td>
            <td>
                <span className="badge bg-warning"
                      id={productType.id}
                      style={{cursor:"pointer"}}
                      onClick={EditProductType}>Redaktə</span>
            </td>
        </tr>
    )

    return (<div>
            {isCreateProductType &&
            <AddDataModal
                show={isCreateProductType}
                productType={productTypes}
                addProductTypeTh={props.addProductTypeTh}
                setIsCreateProductType={setIsCreateProductType}
                {...props}
            />}
            {isEditProductType &&
            <EditDataModal
                show={isEditProductType}
                setIsEditProductType={setIsEditProductType}
                productTypeId={productTypeId}
                productTypes={productTypes}
                updateProductTypeTh={props.updateProductTypeTh}
                deleteProductTypeTh={props.deleteProductTypeTh}
                // updateProductType={updateProductTypeTh}
                {...props}
            />}
            <div className="card ml-1 mr-1 ">
                <div className="card-header">
                    <h3 className="card-title">Məhsul</h3>
                    <div className="card-tools">
                        {/*<Paginator*/}
                        {/*    totalElements={props.totalElements}*/}
                        {/*    totalPages={props.totalPages}*/}
                        {/*    size={props.size}*/}
                        {/*    getNewPorsion={props.getProductTypesTh}*/}
                        {/*/>*/}
                    </div>
                </div>
                <div className="card-body p-0">
                    <table className="table">
                        <thead>
                        <tr>
                            <th style={{width: "10px"}}>Id</th>
                            <th>Adı</th>
                            <th>status</th>
                            <th style={{width: "40px"}}>
                                <span className="badge bg-info"
                                      style={{cursor:"pointer"}}
                                      onClick={AddProductType}>Əlavə Et</span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {productTypesList}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
});

export default ProductTypes;
